import { Card, Stack, Typography } from "@mui/material";
import React from "react";

const ValueCard = ({ title, definition }) => {
  return (
    <Card
      className="v-card"
      sx={{
        height: "100%",
        minHeight: 280,
        borderRadius: 3,
        boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
        transition: "all 0.3s ease",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: "0 8px 30px rgba(0,0,0,0.15)"
        }
      }}
    >
      <Stack height="75%" justifyContent="center" alignItems="center" sx={{ p: 3 }}>
        <Typography
          textAlign="center"
          variant="body1"
          sx={{ 
            width: "100%", 
            padding: 2,
            lineHeight: 1.6,
            color: "text.secondary"
          }}
        >
          {definition}
        </Typography>
      </Stack>
      <Stack
        height="25%"
        justifyContent="center"
        alignItems="center"
        sx={{ 
          backgroundColor: "primary.main",
          borderBottomLeftRadius: 12,
          borderBottomRightRadius: 12
        }}
      >
        <Typography
          textTransform="uppercase"
          color="#FFFFFF"
          fontWeight="bold"
          padding={2}
          variant="h6"
          sx={{ textAlign: "center" }}
        >
          {title}
        </Typography>
      </Stack>
    </Card>
  );
};

export default ValueCard;
